import React, {useEffect, useState} from 'react';
import stringUtils from "../../../../utils/string_utils";
import {
    styleContainerList,
    styleListingOutLine,
    styleTableCellHeader
} from "../../../../utils/common_style_for_list";
import {
    TableCell,
    TableContainer,
    TableHead,
    Table,
    TableBody, TableRow,
} from "@mui/material";
import {commonTaskApiCall} from "../../../controllers/unassigned_controllers";
import {CommonTaskModel} from "../../../models/unassigned_task_model";
import {v4 as uuidv4} from "uuid";
import Skeleton from "@mui/material/Skeleton";
import CommonColorUtils from "../../../../utils/common_colors";
import {
    convertTo12Hour,
    localDateFormatWithMonthName,
    localTimeFormat
} from "../../../../utils/date_time_convert_utils";
import CommonTextWithRoundedShape from "../../../../components/CommonTextWithRoundedShape";
import No_Record_Found_Page from "../no_record_found_page";
import PickupOrderDetailsScreen from "../order_details_pages/pickup_order_details_screen";
import RtoOrderDetailsScreen from "../order_details_pages/rto_order_details_screen";
import ReturnOrderDetailsScreen from "../order_details_pages/return_order_deatails_screen";

const CompleteTaskPage = ({selectedHubId,setCommonCount=()=>{}}) => {
    const [isBusy, setIsBusy] = useState(false);
    const [completedTaskList, setCompletedTaskList] = useState([]);
    const [selectedTaskId, setSelectedTaskId] = useState('');
    const [pickUpDialogOpen, setPickUpDialogOpen] = useState(false);
    const [selectedOrderDriver, setSelectedOrderDriver] = useState('');
    const [rtoDialogOpen, setRtoDialogOpen] = useState(false);
    const [returnDialogOpen, setReturnDialogOpen] = useState(false);

    const handlePickupDialogOpen = () => {
        setPickUpDialogOpen(true);
    }
    const handlePickupDialogClose = () => {
        setPickUpDialogOpen(false);
    }

    const handleRtoDialogOpen = () => {
        setRtoDialogOpen(true);
    }
    const handleRtoDialogClose = () => {
        setRtoDialogOpen(false);
    }
    const handleReturnDialogOpen = () => {
        setReturnDialogOpen(true);
    }
    const handleReturnDialogClose = () => {
        setReturnDialogOpen(false);
    }

    const columns = [
        {id: "clientLocation", label: stringUtils.pickupLocation,width: "150px" },
        {id: "address", label: stringUtils.pickupAddress,  width: "150px" },
        {id: "vendorName", label: stringUtils.vendorName, width: "150px"},
        {id: "destinationHubLocationName", label: stringUtils.destinationHub,width: "150px" },
        {id: "visitTime", label: stringUtils.visitTime,width: "80px" },
        {id: "taskId", label: stringUtils.taskId,  width: "100px" },
        {id: "tasksType", label: stringUtils.tasks, width: "100px" },
        {id: "driverName", label: stringUtils.driver, width: "80px" },
        {id: "updatedAt", label: stringUtils.lastUpdatedAt, width: "120px" },
    ];

    const tableCellSkeleton = (
        <Skeleton variant="rectangular" width={100} height={30}/>
    );
    const completeTaskApiCalling = async () => {
        try {
            setIsBusy(true);
            const response = await commonTaskApiCall('completed');
            const commonTaskModel = CommonTaskModel.fromJson(response);
             setCommonCount((prevCount) => ({
                    ...prevCount,
                    completedCount: response?.task_count||0,
                }));
            setCompletedTaskList(commonTaskModel.taskLocation);
        } catch (e) {
            setCompletedTaskList([]);
            console.log(e);
        } finally {
            setIsBusy(false);
        }
    }

    const openOrderDetailsPage = (orderType, taskId, driverName) => {
        setSelectedTaskId(taskId);
        setSelectedOrderDriver(driverName)
        if (orderType.toLowerCase() === 'pick up') {
            handlePickupDialogOpen();
        }
        else if(orderType.toLowerCase() === 'rto') {
            handleRtoDialogOpen()
        }
        else if(orderType.toLowerCase() === 'return') {
            handleReturnDialogOpen()
        }
    }

    useEffect(() => {
        completeTaskApiCalling();
    }, [selectedHubId]);

    const spanStyle = {
        display: "flex",
        alignItems: "left",
        flexDirection: "column",
        whiteSpace: "normal",
        wordWrap: "break-word",
    }

    return (
        <>
            <div style={styleListingOutLine}>
                {!isBusy && completedTaskList.length === 0 ? (
                    <No_Record_Found_Page noRecordTitle={stringUtils.noCompleteTasks}
                                          noRecordDescription={stringUtils.driverAssignmentIsNotYetDone}/>
                ) : (
                    <>
                        {isBusy ? (<>
                            {Array.from({length: 20}).map((_, index) => (
                                <div>
                                    <Skeleton
                                        key={index}
                                        variant="rectangular"
                                        width={'100%'}
                                        height={80}
                                        style={{
                                            marginBottom: '8px', flex: 1,
                                            overflowX: 'auto',
                                        }} // Optional styling for spacing
                                    />
                                </div>
                            ))}
                        </>) : (
                            <div
                                style={{overflowY: 'auto', ...(!localStorage.getItem('isFromHostApplication') ? {height: 'calc(75vh)'} : {height: 'calc(70vh)'})}}>
                                <TableContainer style={{...styleContainerList, maxHeight: "100%"}}>
                                    <Table stickyHeader style={{tableLayout: 'fixed'}}>
                                        <TableHead>
                                            <TableRow>
                                                {columns.map((column) => (
                                                    <TableCell align={"left"} style={{...styleTableCellHeader,width:column.width}}>
                                                        {column.label}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>

                                            {
                                                completedTaskList.map((row, rowIndex) => (
                                                    <>
                                                        <TableRow
                                                            key={rowIndex}
                                                            style={{
                                                                backgroundColor: CommonColorUtils.kPrimaryPureWhite,
                                                            }}
                                                        >
                                                            {columns.map((column, columnIndex) => (
                                                                <TableCell
                                                                    key={`${rowIndex}-${columnIndex}`}
                                                                    align={"left"}
                                                                    style={{
                                                                        padding: "0px",
                                                                        paddingLeft: column.id === 'taskType' ? '0px' : "10px",
                                                                        paddingRight: "20px",
                                                                        height: "54px",
                                                                        borderBottom: `1px solid ${CommonColorUtils.primaryGrey300}`,
                                                                        width: `${100 / columns.length}%`,
                                                                        fontFamily: "Inter, Arial, sans-serif",
                                                                        color: CommonColorUtils.primaryGrey700,
                                                                        fontWeight:
                                                                            column.id === "clientLocation" ? 600 : 400,
                                                                        fontSize: "14px",
                                                                    }}
                                                                >
                                                                    {(() => {
                                                                        if (column.id === "tasksType") {
                                                                            let colorText = CommonColorUtils.kPrimeGreenDarker;
                                                                            let colorBG = CommonColorUtils.kPrimeGreenDarkShade;
                                                                            if (row[column.id]?.type.toLowerCase() === 'return') {
                                                                                colorBG = CommonColorUtils.kPrimePurpleLightShade;
                                                                                colorText = CommonColorUtils.kPrimePurpleDarkShade;
                                                                            }
                                                                            if (row[column.id]?.type.toLowerCase() === 'rto') {
                                                                                colorBG = CommonColorUtils.krtoBackgroundColor;
                                                                                colorText = CommonColorUtils.krtoTextColor;
                                                                            }
                                                                            if (row['status'] === 'CANCELLED') {
                                                                                colorBG = CommonColorUtils.primaryErrorLightRed;
                                                                                colorText = CommonColorUtils.primaryErrorDarkColor;
                                                                            }
                                                                            return (
                                                                                <>
                                                                                    <div
                                                                                        onClick={() => openOrderDetailsPage(row[column.id].type, row['taskId'], row['driverName'])}
                                                                                        style={{
                                                                                            marginRight: '30px',
                                                                                            cursor: 'pointer'
                                                                                        }}>
                                                                                        <CommonTextWithRoundedShape
                                                                                            text={`${row[column.id].type} (${row[column.id].count})`}
                                                                                            backgroundColor={
                                                                                                colorBG
                                                                                            }
                                                                                            color={
                                                                                                colorText
                                                                                            }
                                                                                            verticalPadding={0}
                                                                                            leftMarging={0}

                                                                                        />
                                                                                    </div>
                                                                                </>
                                                                            );
                                                                        } else if (column.id === 'visitTime') {
                                                                            return <span style={{...spanStyle,width:column.width}}>
                                                                            {convertTo12Hour(row[column.id])}
                                                                        </span>;
                                                                        } else if (column.id === 'updatedAt') {
                                                                            return `${localDateFormatWithMonthName(row[column.id])} at ${localTimeFormat(row[column.id])}`;
                                                                        } else {
                                                                            return <div style={{...spanStyle,width:column.width}}>
                                                                            {row[column.id]}
                                                                        </div>;
                                                                        }
                                                                    })()}
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                    </>
                                                ))
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                                )}
                            </>
                        )}

            </div>
            <PickupOrderDetailsScreen open={pickUpDialogOpen} onClose={handlePickupDialogClose}
                                      navigatedFrom={stringUtils.completedTasks} taskId={selectedTaskId}
                                      driverName={selectedOrderDriver}/>
            <RtoOrderDetailsScreen open={rtoDialogOpen} onClose={handleRtoDialogClose}
                                   navigatedFrom={stringUtils.completedTasks} taskId={selectedTaskId} driverName={selectedOrderDriver}/>
            <ReturnOrderDetailsScreen open={returnDialogOpen} onClose={handleReturnDialogClose}
                                      navigatedFrom={stringUtils.completedTasks} taskId={selectedTaskId} driverName={selectedOrderDriver}/>
        </>
    );
}

export default CompleteTaskPage;